import { getRequestGateway } from './api.service'
let aborter = null

export async function getAllRealEstatesv1(cancelPendingRequest, timeout) {
  try {
    const realEstates = {
      type: 'geojson',
      data: {
        id: 'all-realestates',
        type: 'FeatureCollection',
        features: []
      }
    }
    if (cancelPendingRequest && aborter) aborter.abort()
    const res = await Promise.all([
      getRequestGateway('core/v1/realestates', timeout),
      getRequestGateway('core/v1/realestates/geojson', timeout)
    ])
    const response = res[0]
    const responseGeojson = res[1]
    const features = response.data
    const featuresGeojson = responseGeojson.data
    featuresGeojson.forEach((realEstate) => {
      const feature = features.find((feature) => feature.id === realEstate.properties.belongsToId)
      if (feature) {
        realEstate.properties = feature // Replacing properties in geojson response with content from the constructions endpoint
        realEstate.id = realEstate.properties.id // Temporarily replacing id which was wrong (wrong on backend)
        realEstate.properties.belongsToId = realEstate.properties.id
      }
    })
    realEstates.data.features = featuresGeojson
    return realEstates
  } catch (e) {
    console.error(e)
    throw new Error('Could not fetch real estates')
  }
}
export async function getRealEstate(id) {
  const response = await getRequestv1(`/v1/realestates/${id}`)
  return response
}
